import React from "react";
import clsx from "clsx";
import styles from "./_css/switchButton.module.css";

type Props = {
    value: boolean;
    onChange: (value: boolean) => void;
    labelOn?: string;
    labelOff?: string;
    className?: string;
};

export function SwitchButton({ value, onChange, labelOff, labelOn, className }: Props) {
    return (
        <div className={clsx(styles.container, className)}>
            <div
                className={clsx("flex_row_center unselectable justifyContent_spaceAround", styles.toggleBlock)}
                onClick={() => onChange(!value)}
            >
                <div className={clsx(styles.toggle, { [styles.toggled]: value })} />
                <div className={clsx(styles.label, { [styles.selected]: value })}>{labelOn}</div>
                <div className={clsx(styles.label, { [styles.selected]: !value })}>{labelOff}</div>
            </div>
        </div>
    );
}
